export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/stylus-loader/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CategoryFooter.vue?vue&type=style&index=0&id=0fc0ce9d&lang=stylus&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/CategoryFooter.vue?vue&type=style&index=0&id=0fc0ce9d&lang=stylus&scoped=true
// module id = 231
// module chunks = 4 6 7 8 9 10